/// <amd-module name="Widgets/SprintOverviewWidget/clients/Core" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\dashboards\widgets\sprint-overview-widget-content\genclient.json
 */

import { IVssPageContext, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Core from "Tfs/Platform/Contracts/Core";

import { ICoreRestClient } from "Widgets/SprintOverviewWidget/clients/Core.Types";

export { ICoreRestClient } from "Widgets/SprintOverviewWidget/clients/Core.Types";

class CoreRestClient extends RestClientBase implements ICoreRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Get a specific team.
     * 
     * @param projectId - The name or ID (GUID) of the team project containing the team.
     * @param teamId - The name or ID (GUID) of the team.
     * @param expandIdentity - A value indicating whether or not to expand Identity information in the result WebApiTeam object.
     */
    public async getTeam(
        projectId: string,
        teamId: string,
        expandIdentity?: boolean
        ): Promise<Core.WebApiTeam> {

        const queryValues: any = {
            '$expandIdentity': expandIdentity
        };

        return this.beginRequest<Core.WebApiTeam>({
            apiVersion: "5.1-preview.3",
            routeTemplate: "_apis/projects/{projectId}/teams/{*teamId}",
            routeValues: {
                projectId: projectId,
                teamId: teamId
            },
            queryParams: queryValues
        });
    }

}

export const CoreClientName = "SprintOverviewWidget-Tfs.ICoreRestClient";

export function getCoreClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ICoreRestClient {
    return pageContext.getRestClient<ICoreRestClient>(CoreClientName, options);
}

RestClients.add(CoreClientName, { 
    factory: CoreRestClient,
    options: {
        resourceAreaId: "79134c72-4a58-4b42-976c-04e7115f32bf",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
